<template>
  <div
    class="banner-page inner-page contact-page"
    :style="`background-image: url('${getImageUrl(
      menu.image
    )}'); background-size: cover; background-repeat: no-repeat; background-position: center center;`"
  >
    <div class="content">
      <div class="banner-text" :lang="langStore.lang === 'gr' ? 'el' : 'en'">
        {{ menu.title }}
      </div>
      <p>
        {{ menu.description }}
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "BannerPageComponent",

  data() {
    return {
      langStore,
      menu: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchMenu();
    },
  },

  mounted() {
    this.fetchMenu();
  },

  methods: {
    async fetchMenu() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/menu`,
          { params: { lang: this.langStore.lang } }
        );

        this.menu = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },

    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>

<style scoped>
.content p {
  padding-left: 15%;
  padding-right: 15%;
}

</style>
